<div class="modal">
    <div class="container model-container email-verification">
        <div class="modal-header">
            <div class="success-image">
                <img src="/assets/icon/email-verification.svg" alt="Email Icon" width="86" height="100">
            </div>
            <h4 class="header">Email Verification Needed</h4>
        </div>
        <div class="modal-body">
            <div class="modal-content">
                <div class="info">
                    <p>
                        We noticed you signed up with us, but have not verified your email yet.
                    </p>
                </div>
                <div class="row modal-actions">
                    <button class="button primary" (click)="sendCode()">Verify Email Now</button>
                </div>
            </div>
        </div>
    </div>
    </div>